<template>
  <div class="pos-layout-grid__container">
    <Draggable class="pos-layout-grid" v-model="value.list">
      <div class="pos-layout-grid__item" v-for="(listItem, listItemIndex) of value.list">
        <svgicon class="item__icon" src="icon/drag.svg" :height="20" :width="12"></svgicon>
        <div class="item__content">
          <label>{{$t('functions.function')}}</label>
          <select class="item__select" v-model="listItem.id">
            <option :value="null" selected disabled hidden>{{$t('choose')}}...</option>
            <option :value="fn.id" v-for="(fn, fnIndex) of functions" :key="'listItemIndex' + fnIndex + uniqueId">
              {{$to(getListItemFunctionName(listItem, fn))}}
            </option>
          </select>
          <div class="item__edit" @click="editListItem(listItemIndex)">
            <svgicon src="icon/modify-pen.svg" :height="16" :width="16"></svgicon>
          </div>
        </div>
      </div>
      <div class=" pos-layout-grid__item pos-layout-grid__add-item" @click="addListItem" v-if="value.list.length < total">
        <button class="btn-add">
          <svgicon src="icon/add.svg" :height="16" :width="16"></svgicon>
        </button>
      </div>
    </Draggable>

    <Modal dismissable :name="uniqueId + 'edit'" :title="$t('functions.edit_function')" :width="650"
           :actions="[
               {name: $t('back'), action: 'close'},
               {name: $t('delete'), action: deleteListItem},
               {name: $t('confirm'), action: persistEdit, primary: true}]">
      <div v-if="selectedListItem">
        <div class="group">
          <LocalizedInput :title="$t('name')" :translate="selectedListItem.customData.name" :placeholder="getFunctionName(selectedListItem.id)"/>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
  import Draggable from 'vuedraggable';
  import LocalizedInput from "@/components/tools/LocalizedInput";

  export default {
    name: "PosLayoutGrid",

    components: { Draggable, LocalizedInput },

    props: {
      value: Object,
      functions: Array
    },

    data() {
      return {
        uniqueId: null,
        selectedListItemIndex: null
      }
    },

    computed: {
      selectedListItem() {
        if (this.selectedListItemIndex === null) {
          return null;
        }
        return this.value.list[this.selectedListItemIndex];
      },
      nbColumns() {
        return this.value.cols || 0;
      },
      nbRows() {
        return this.value.rows || 0;
      },
      total() {
        return (this.nbColumns * this.nbRows) || 0;
      }
    },

    mounted() {
      this.uniqueId = generateUUID();
    },

    methods: {
      addListItem() {
        this.value.list.push({
          id: null,
          customData: {
            name: {fr: "", en: ""}
          }
        });
      },
      deleteListItem() {
        let index = this.selectedListItemIndex;
        this.$modal.show(this.uniqueId + "edit", false);
        this.selectedListItemIndex = null;
        this.value.list.splice(index, 1);
      },
      getListItemFunctionName(listItem, fn) {
        if (!listItem) {
          return;
        }
        if (listItem.id !== fn.id) {
          return fn.name;
        }
        if (listItem.customData && listItem.customData.name && this.$to(listItem.customData.name)) {
          return listItem.customData.name;
        }
        return this.getFunctionName(listItem.id);
      },
      getFunctionName(id) {
        let fn = this.functions.find(f => f.id === id);
        return fn ? fn.name : {};
      },
      editListItem(index) {
        console.log("edit");
        this.selectedListItemIndex = index;
        this.$modal.show(this.uniqueId + "edit");
      },
      persistEdit() {

      }
    }
  }
</script>

<style lang="scss" scoped>
  .pos-layout-grid {
    display: flex;
    flex-wrap: wrap;
  }
  .pos-layout-grid__item {
    width: calc(25% - 20px);
    background-color: #f5f5f5;
    border-radius: 6px;
    margin: 10px;
    height: 90px;
    display: flex;
    align-items: center;
    padding: 14px;
    cursor: grab;
    position: relative;

    .item__select {
      width: 100%;
      font-size: 16px;
      text-transform: capitalize;
    }

    .item__content {
      display: flex;
      flex-direction: column;
    }

    .item__icon {
      fill: #fc6650;
      margin-right: 14px;
      flex-shrink: 0;
    }

    .item__edit {
      position: absolute;
      padding: 13px;
      top: 0;
      right: 0;
      fill: #bfbfbf;
      cursor: pointer;
    }
  }
  .pos-layout-grid__add-item {
    border: 2px dashed #fc6650;
    cursor: pointer;
    justify-content: center;
    z-index: 0;

    .btn-add {
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: #fc6650;
      fill: white;
      padding: 12px;
      border: none;
      border-radius: 6px;
      cursor: pointer;
    }
  }
</style>